import experiment from 'experiment';
// New
import { coreUtils } from '@wix/santa-ds-libs/basic';
// Old
import { fontsMetaData } from '@wix/thunderbolt-fonts';
import coreUtilsLib from '@wix/santa-core-utils';

export const fontUtils = experiment.isOpen('se_newFontsDataSource')
  ? coreUtils.fontUtils.createFontUtils(true)
  : coreUtilsLib.createFontUtils(fontsMetaData);
